export default {
  setEventUuid(eventUuid) {
    window.localStorage.setItem("event_uuid", eventUuid)
  },
  getEventUuid() {
    return window.localStorage.getItem("event_uuid")
  },
  removeEventUuid() {
    window.localStorage.removeItem("event_uuid")
  },
}
